/* eslint-disable */
import { css } from 'linaria';
import '@jetshop/ui/Theme/sanitizeCss';

css`
  :global() {
    ${resets};
  }
`;

const fallbackStyles = `
  font-family: 'Titillium Web', sans-serif;
  font-size: 16px;
  line-height: 1.6;
  word-spacing: -0.1px;
  font-weight: 400;
  visibility: visible;
`;

const resets = `
    html,
    body {
      height: 100%;
      font-family: 'Titillium Web', sans-serif;
      margin: 0;
    }
    html,
    body,
    #root {
      min-height: 100%;
    }
    #root {
      display: flex;
      flex-direction: column;
    }
    button {
      cursor: pointer;
      padding: 0px;
      border: none;
      font: inherit;
    }
    ol,
    ul,
    h4,
    h3,
    h2,
    h1 {
      list-style: none;
      margin: 0;
      padding: 0;
    }
    p,
    dd {
      margin: 0;
      padding: 0;
    }
    input {
      -webkit-appearance: none;
    }
    .ReactModal__Body--open {
      overflow: hidden;
    }
    .ReactModal__Overlay--after-open {
      overflow: scroll;
      z-index: 9;
    }
    body {
      ${fallbackStyles};
      -webkit-font-smoothing: antialiased;
    }
    /* 
   * apply a natural box layout model to all elements, but allowing components
   * to change */
    html {
      box-sizing: border-box;
    }
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
`;
